<template>
  <main-nav-v-2
    @logout="logout()"
  ></main-nav-v-2>
</template>

<script>
// Live shell always uses MainNavV2 (MainNavV1 was unused and removed).
import MainNavV2 from '@/components/layout/MainNavV2.vue';

export default {
  name: 'MainNav',

  components: {
    MainNavV2,
  },

  data() {
    return {
      //
    };
  },

  methods: {

    logout: function () {
      this.$emit('logout');
    },

  },
};
</script>
